"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateLeagueChannelMappingDto = instanceOfUpdateLeagueChannelMappingDto;
exports.UpdateLeagueChannelMappingDtoFromJSON = UpdateLeagueChannelMappingDtoFromJSON;
exports.UpdateLeagueChannelMappingDtoFromJSONTyped = UpdateLeagueChannelMappingDtoFromJSONTyped;
exports.UpdateLeagueChannelMappingDtoToJSON = UpdateLeagueChannelMappingDtoToJSON;
exports.UpdateLeagueChannelMappingDtoToJSONTyped = UpdateLeagueChannelMappingDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateLeagueChannelMappingDto interface.
 */
function instanceOfUpdateLeagueChannelMappingDto(value) {
    if (!('reason' in value) || value['reason'] === undefined)
        return false;
    return true;
}
function UpdateLeagueChannelMappingDtoFromJSON(json) {
    return UpdateLeagueChannelMappingDtoFromJSONTyped(json, false);
}
function UpdateLeagueChannelMappingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'youtube_channel_id': json['youtube_channel_id'] == null ? undefined : json['youtube_channel_id'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'reason': json['reason'],
    };
}
function UpdateLeagueChannelMappingDtoToJSON(json) {
    return UpdateLeagueChannelMappingDtoToJSONTyped(json, false);
}
function UpdateLeagueChannelMappingDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'youtube_channel_id': value['youtube_channel_id'],
        'priority': value['priority'],
        'reason': value['reason'],
    };
}
